import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import BigAdd from './BigAdd'
import ButtonTags from './ButtonTags'
import SocialMediaShare from './SocialMediaShare'
import TajaKhabar2 from './TajaKhabar2'
import TajaKhabar3 from './TajaKhabar3'
import TajaKhabar4 from './TajaKhabar4'
import TajaKhabar5 from './TajaKhabar5'
// import FakeKhabre from './FakeKhabre'
import { Circles } from "react-loader-spinner";
import DOMPurify from 'dompurify'; // For sanitizing HTML content
import { faFacebook, faXTwitter, faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import './style1.css';

const BASE_URL = "https://api.shabdtoday.com/";
const base_URL = "https://localhost:44351/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const local = "https://localhost:44351/api/home/getOpinionDetails/"
const online = "https://api.shabdtoday.com/api/home/getOpinionDetails/"

function OpinionDetails() {

    const { mainKhabarId } = useParams();
    const [newsDetails, setNewsDetails] = useState(null);
    useEffect(() => {
        const fetchNewsDetails = async () => {
            try {
                const { data } = await axios.get(`${online}${mainKhabarId}`);
                console.log("Fetched data:", data);
                setNewsDetails(data);
            } catch (error) {
                console.error("Error fetching news details:", error);
            }
        };

        fetchNewsDetails();
    }, [mainKhabarId]);

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength);
        }
        return text;
    };

    const formatDateInHindi = (dateString) => {
        const date = new Date(dateString);
        const monthsInHindi = [
            "जनवरी",
            "फरवरी",
            "मार्च",
            "अप्रैल",
            "मई",
            "जून",
            "जुलाई",
            "अगस्त",
            "सितंबर",
            "अक्टूबर",
            "नवंबर",
            "दिसंबर",
        ];
        const seconds = date.getSeconds();
        const minute = date.getMinutes();
        var hour = date.getHours();
        const day = date.getDate();
        const month = monthsInHindi[date.getMonth()];
        const year = date.getFullYear();
        const amPm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
    };

    const stripHtmlTags = (html, maxLength) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const strippedText = tempDiv.textContent || tempDiv.innerText || "";
        return truncateText(strippedText, maxLength);
    };
    const generateShareLinks = (mainKhabarId, opinion_Hedding) => {
        const encodedopinion_Hedding = encodeURIComponent(opinion_Hedding);
        const url = `${window.location.origin}/MadhyaPradeshDetailsD/${mainKhabarId}`;
        return {
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedopinion_Hedding}`,
            whatsapp: `https://api.whatsapp.com/send?text=${encodedopinion_Hedding} ${url}`,
            twitter: `https://twitter.com/intent/tweet?text=${encodedopinion_Hedding}&url=${url}`,
            instagram: `https://www.instagram.com/`


        };
    };

    if (!newsDetails) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                {/* <Circles
                    height="30"
                    width="30"
                    color="#f7265c"
                    ariaLabel="circles-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                /> */}
            </div>
        );
    }

    const renderHtmlContent = (html) => {
        const sanitizedHtml = DOMPurify.sanitize(html);
        return { __html: sanitizedHtml };
    };

    return (
        <div>
            <div className="ak-post-wrapper" style={{ transform: "none" }}>
                <div
                    className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
                    style={{ transform: "none" }}
                >
                    <div className="ak-container" style={{ transform: "none" }}>

                        <div className="ak-content" style={{ transform: "none" }}>
                            <div className="containercustome" style={{ transform: "none" }}>
                                <div className='mt-2'>
                                    <BigAdd />
                                </div>
                                <div className="row grid-container" style={{ transform: "none" }}>
                                    <div className="grid-item ak_column_1 col-md-3 sidebar-column sidebar-column-primary sticky-sidebar"
                                        style={{
                                            position: "relative",
                                            overflow: "visible",
                                            boxSizing: "border-box",
                                            minHeight: 1
                                        }}
                                    >
                                        <div
                                            className="theiaStickySidebar"
                                            style={{
                                                paddingTop: 0,
                                                paddingBottom: 1,
                                                position: "sticky",
                                                transform: "none",
                                                top: 0,
                                                left: "914.5px"
                                            }}
                                        >
                                            <div className="sidebar post-sidebar">


                                                <TajaKhabar3 />
                                                {/* <FakeKhabre /> */}
                                                {/* <SocialMediaShare /> */}


                                            </div>
                                            <div
                                                className="resize-sensor"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                    zIndex: -1,
                                                    visibility: "hidden"
                                                }}
                                            >
                                                <div
                                                    className="resize-sensor-expand"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "all 0s ease 0s",
                                                            width: 410,
                                                            height: 1260
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="resize-sensor-shrink"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "0s",
                                                            width: "200%",
                                                            height: "200%"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid-item ak_column_2 col-md-6">
                                        <header className="entry-header ak-post-header mb-2">
                                            <div className="ak-post-badges" />

                                            <span style={{ color: "crimson", marginRight: 3, fontSize: 25 }} className="ak-post-title mt-2">
                                                {newsDetails.opinionWithMember &&
                                                    stripHtmlTags(
                                                        newsDetails.opinionWithMember.opinion_Tag,
                                                        60
                                                    )}:
                                            </span>
                                            <span className="ak-post-summary mb-2">
                                                {newsDetails.opinionWithMember &&
                                                    stripHtmlTags(
                                                        newsDetails.opinionWithMember.opinion_Heading,
                                                        150
                                                    )}
                                            </span>
                                        </header>
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: 15, marginBottom: 15 }}>
                                            <img
                                                src={BASE_URL + newsDetails.opinionWithMember.member_Image}
                                                alt="Profile"
                                                style={{ width: "70px", height: "70px", borderRadius: "50%" }}
                                            />

                                            <div>

                                                <p style={{ margin: "0", fontWeight: "bold", color: "crimson" }}>{newsDetails.opinionWithMember.member_Name}</p>
                                                <p style={{ margin: "0", fontSize: "14px", color: "gray" }}>
                                                    <u>
                                                        <span style={{ marginRight: 10, color: "" }}>{newsDetails.opinionWithMember.opinion_Tag},</span>
                                                    </u>
                                                    <span style={{ marginRight: 5 }}>Updated:</span>
                                                    {formatDateInHindi(newsDetails.opinionWithMember.opinion_Date)}</p>
                                            </div>
                                        </div>

                                        <div className="ak-article-inner">
                                            <div className="ak-article-inner">
                                                <div className="ak-post-featured">
                                                    <div className="ak-featured-cover">
                                                        <Link href="wp-content/uploads/sites/26/2022/10/post-18.jpg" aria-label="whatsapp">
                                                            <div
                                                                className="ak-featured-thumb  size-auto"
                                                                style={{ paddingBottom: "70%" }}
                                                            >
                                                                <img
                                                                    width={750}
                                                                    height={375}
                                                                    src={BASE_URL + newsDetails.opinionWithMember.opinion_Image}
                                                                    className="attachment-newsy_750x375 size-newsy_750x375 wp-post-image lazyautosizes lazyloaded"
                                                                    alt="taza Khabar"
                                                                    decoding="async"
                                                                    fetchpriority="high"
                                                                    data-src={BASE_URL + newsDetails.opinionWithMember.opinion_Image}
                                                                    data-sizes="auto"
                                                                    data-srcset={BASE_URL + newsDetails.opinionWithMember.opinion_Image}
                                                                    data-expand={700}
                                                                    sizes="750px"
                                                                    srcSet={BASE_URL + newsDetails.opinionWithMember.opinion_Image}
                                                                />
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>

                                                <div className="d-flex" style={{ justifyContent: "space-between", alignItems: "center" }}>
                                                    <div
                                                        className="mb-1"
                                                        style={{
                                                            marginRight: window.innerWidth > 668 ? 280 : 90,
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {/* {newsDetails.opinionWithMember &&
                                                            stripHtmlTags(formatDateInHindi(newsDetails.opinionWithMember.opinion_Date), 150)} */}
                                                    </div>
                                                    {/* <div>
                                                        <span>
                                                            <i
                                                                className="fa fa-eye"
                                                                style={{ fontSize: 12 }}
                                                                aria-hidden="true"
                                                            >
                                                                {newsDetails.opinion.viewCount}
                                                            </i>
                                                        </span>
                                                    </div> */}
                                                </div>

                                                {/* <div className="text-dark" style={{ fontWeight: 600 }} >
                                                    Reporter: {newsDetails.opinion &&
                                                        stripHtmlTags(
                                                            newsDetails.opinion.reporter,
                                                            50
                                                        )}
                                                </div>
                                                <div className="text-dark" style={{ marginRight: "0px", fontWeight: 600 }}>
                                                    Editor: {newsDetails.opinion &&
                                                        stripHtmlTags(
                                                            newsDetails.opinion.editor,
                                                            50
                                                        )}
                                                </div> */}
                                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <Link style={{ fontSize: 22, color: "grey" }} to={generateShareLinks(newsDetails.opinionWithMember.id, newsDetails.opinionWithMember.opinion_Heading).facebook} target="_blank" rel="noopener noreferrer" aria-label="facebook"> <FontAwesomeIcon icon={faFacebook} style={{ color: "#1877F2", fontSize: "24px" }} /></Link>
                                                    &nbsp;&nbsp;  &nbsp;&nbsp;
                                                    <Link style={{ fontSize: 22, color: "grey" }} to={generateShareLinks(newsDetails.opinionWithMember.id, newsDetails.opinionWithMember.opinion_Heading).whatsapp} target="_blank" rel="noopener noreferrer" aria-label="whatsapp"><FontAwesomeIcon icon={faWhatsapp} style={{ color: "#25D366", fontSize: "24px" }} /></Link>
                                                    &nbsp;&nbsp;  &nbsp;&nbsp;
                                                    <Link style={{ fontSize: 22, color: "grey" }} to={generateShareLinks(newsDetails.opinionWithMember.id, newsDetails.opinionWithMember.opinion_Heading).twitter} target="_blank" rel="noopener noreferrer" aria-label="twitter"><FontAwesomeIcon icon={faXTwitter} style={{ color: "#1DA1F2", fontSize: "24px" }} /></Link>
                                                    &nbsp;&nbsp;  &nbsp;&nbsp;
                                                    <Link style={{ fontSize: 22, color: "grey" }} to={generateShareLinks(newsDetails.opinionWithMember.id, newsDetails.opinionWithMember.opinion_Heading).instagram} target="_blank" rel="noopener noreferrer" aria-label="instagram"><FontAwesomeIcon icon={faInstagram} style={{ color: "#E4405F", fontSize: "24px" }} /></Link>
                                                </div>


                                                {/* <div className="ak-post-content">
                                                    <p
                                                        className=""
                                                        id=""
                                                        dangerouslySetInnerHTML={renderHtmlContent(newsDetails.opinion.newsDetails)}
                                                    />
                                                </div> */}
                                                <ButtonTags />
                                            </div>



                                        </div>

                                    </div>
                                    <div
                                        className="grid-item ak_column_1 col-md-3 sidebar-column sidebar-column-primary-right sticky-sidebar"
                                        style={{
                                            position: "relative",
                                            overflow: "visible",
                                            boxSizing: "border-box",
                                            minHeight: 1
                                        }}
                                    >
                                        <div
                                            className="stickybar"
                                            style={{
                                                paddingTop: 0,
                                                paddingBottom: 1,
                                                position: "sticky",
                                                transform: "none",
                                                top: 0,
                                                left: "914.5px"
                                            }}
                                        >
                                            <div className="sidebar post-sidebar">

                                                <TajaKhabar2 />
                                                <TajaKhabar5 />
                                                {/* <SmallAdd /> */}
                                                <div className='mt-2'>
                                                    <TajaKhabar4 />
                                                </div>


                                            </div>
                                            <div
                                                className="resize-sensor"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                    zIndex: -1,
                                                    visibility: "hidden"
                                                }}
                                            >
                                                <div
                                                    className="resize-sensor-expand"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "all 0s ease 0s",
                                                            width: 410,
                                                            height: 1260
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="resize-sensor-shrink"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "0s",
                                                            width: "200%",
                                                            height: "200%"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>


        </div>
    )
}

export default OpinionDetails
